import React from "react";
import { ShieldCheck, Clock, Users, MessageSquare } from "lucide-react";

/**
 * Thin trust strip shown between Hero and Services on the Landing page.
 * Placed at the moment the visitor's doubt spikes ("is this legit?").
 * Numbers here (1,200+ founders) match the Hero stats — no fabrication.
 */
const ITEMS = [
  {
    Icon: ShieldCheck,
    title: "MCA · Trademark · Domain",
    sub: "Every name verified across 3 registries",
  },
  {
    Icon: Clock,
    title: "24-Hour Turnaround",
    sub: "Reports delivered on WhatsApp + Email",
  },
  {
    Icon: Users,
    title: "1,200+ Founders Served",
    sub: "Indian residents, NRIs & HNIs",
  },
  {
    Icon: MessageSquare,
    title: "Reply Within 2 Hours",
    sub: "Talk to a real advisor, not a chatbot",
  },
];

export default function TrustStrip() {
  return (
    <section
      className="bg-black text-white border-y border-black"
      data-testid="trust-strip"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-7 sm:py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-6">
          {ITEMS.map(({ Icon, title, sub }) => (
            <div
              key={title}
              className="flex items-start gap-3"
              data-testid={`trust-item-${title.split(" ")[0].toLowerCase()}`}
            >
              <span className="mt-0.5 inline-flex w-9 h-9 shrink-0 items-center justify-center border border-[#EAB308]/60 bg-[#EAB308]/10">
                <Icon size={17} strokeWidth={2} className="text-[#EAB308]" />
              </span>
              <div className="min-w-0">
                <p className="font-heading font-bold text-sm sm:text-base leading-tight">
                  {title}
                </p>
                <p className="text-[11px] sm:text-xs text-white/60 mt-1 leading-snug">
                  {sub}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
